/**
 * Lifestyle shot swap for product cards.
 * Desktop (hover-capable): handled entirely by CSS :hover — this script does nothing.
 * Touch devices: swaps to the second product image after the card has been pressed
 * and held for a beat, mirroring hover rather than firing on scroll position or
 * flashing instantly on first touch. A quick tap (the common case, navigating to
 * the product) never triggers the swap since it releases before the delay elapses.
 * Event delegation on document covers every card grid on the site (collection grid,
 * related products, quick-add, recently viewed, wishlist) and any cards rendered
 * asynchronously later, without per-feature wiring.
 */
(function () {
  if (!window.matchMedia('(hover: none)').matches) return;

  var REVEAL_DELAY = 2200;
  var timers = new WeakMap();

  function cardFromTouch(target) {
    var card = target.closest && target.closest('.p-card');
    if (!card || !card.querySelector('.p-img-secondary')) return null;
    return card;
  }

  function clearTimer(card) {
    var t = timers.get(card);
    if (t) {
      clearTimeout(t);
      timers.delete(card);
    }
  }

  document.addEventListener('touchstart', function (e) {
    var card = cardFromTouch(e.target);
    if (!card) return;
    clearTimer(card);
    timers.set(card, setTimeout(function () {
      card.classList.add('in-view');
    }, REVEAL_DELAY));
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    var card = cardFromTouch(e.target);
    if (!card) return;
    clearTimer(card);
    card.classList.remove('in-view');
  }, { passive: true });

  document.addEventListener('touchcancel', function (e) {
    var card = cardFromTouch(e.target);
    if (!card) return;
    clearTimer(card);
    card.classList.remove('in-view');
  }, { passive: true });
})();
